import { useLocaleState } from "ra-core";

// Textes d'une fiche dans la langue affichée (chantier multilingue, étape 3) : la version française en français,
// l'anglais sinon, et l'anglais tant que la fiche n'est pas traduite (`radar translate` passe chaque nuit).
type ProjectTexts = {
  name?: string | null;
  name_fr?: string | null;
  description?: string | null;
  description_fr?: string | null;
  structure_type?: string | null;
  structure_type_fr?: string | null;
  name_original?: string | null;
};

const pick = (
  english: string | null | undefined,
  french: string | null | undefined,
  locale: string,
) => (locale === "fr" && french ? french : (english ?? null));

export const projectName = (p: ProjectTexts | undefined, locale: string) =>
  pick(p?.name, p?.name_fr, locale) ?? "";

export const projectDescription = (
  p: ProjectTexts | undefined,
  locale: string,
) => pick(p?.description, p?.description_fr, locale);

export const projectStructureType = (
  p: ProjectTexts | undefined,
  locale: string,
) => pick(p?.structure_type, p?.structure_type_fr, locale);

// Nom écrit dans la source, montré sous le titre quand il diffère du nom affiché.
export const projectOriginalName = (
  p: ProjectTexts | undefined,
  locale: string,
) =>
  p?.name_original && p.name_original !== projectName(p, locale)
    ? p.name_original
    : null;

export const useProjectText = () => {
  const [locale = "fr"] = useLocaleState();
  return {
    locale,
    name: (p?: ProjectTexts) => projectName(p, locale),
    description: (p?: ProjectTexts) => projectDescription(p, locale),
    structureType: (p?: ProjectTexts) => projectStructureType(p, locale),
    originalName: (p?: ProjectTexts) => projectOriginalName(p, locale),
  };
};
